module.exports = __webpack_public_path__ + "static/media/six.46db48fa.svg";